// extracted by mini-css-extract-plugin
export default {"image":"styles_image__WqLI6","overlay":"styles_overlay__vNv1Z","visible":"styles_visible__Xi2zl"};